/** US 14967 — navigation and page titles for VQA library request surfaces. */
export const VQA_LIBRARY_REQUESTS_LABEL = "VQA Library Requests";
export const VQA_REPORT_LIBRARY_LABEL = "VQA Report Library";
